import React from 'react'
// , { useRef, useEffect }
// import SlidInActivityDetail from '@/components/slide-in-activity-detail'
import Resources from './resourcesApply'
import Container from '@/components/container'
export default (props) => {
  // const abc = useRef(null)

  // useEffect(() => {
  //   abc.current.show('id')
  // }, [])

  return (
    <Container>
      {/* <SlidInActivityDetail ref={abc} /> */}
      <Resources />
    </Container>
  )
}
